import LinearProgress from '@mui/material/LinearProgress';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import React from 'react';
import DashboardPage from '../../components/Dashboard/DashboardPage';
import withApollo from '../../lib/withApollo';

const Publish = dynamic(() => import('../../components/Dashboard/Publish'), {
  loading: () => <LinearProgress color="primary" />,
  ssr: false,
});

const PublishPage = () => {
  const router = useRouter();

  const {
    permlink,
    draftId,
    clone,
    community,
    youtubeId,
    open,
    longitude,
    latitude,
  } = router.query;

  return (
    <DashboardPage
      open={open}
      bottomNav={1}
      includeMapbox
      label="publish"
      content={
        // On a hard load this page is statically optimised, so `router.query` is
        // empty until hydration finishes: for one render `draftId` looks absent
        // and Publish starts a BLANK post, then swaps the draft in underneath
        // itself when the query arrives. That flashed an empty title and, worse,
        // handed the editor a document it had not parsed yet. Wait for the real
        // query — the editor is a client-only chunk with a progress bar anyway.
        !router.isReady ? (
          <LinearProgress color="primary" />
        ) : (
          <Publish
            // Keyed on the editing target: going from one target to another
            // (blank → resumed draft, draft → draft) remounts a fresh editor
            // that loads through the normal fetch path, instead of swapping a
            // different post into a mounted editor's state underneath it.
            key={`${draftId || ''}|${permlink || ''}|${youtubeId || ''}|${clone ||
              ''}`}
            youtubeId={youtubeId}
            permlink={permlink}
            draftId={draftId}
            clone={clone}
            community={community}
            initialLocation={{ longitude, latitude }}
          />
        )
      }
    />
  );
};

export default withApollo(PublishPage);
